export default __webpack_public_path__ + "img/habitation.668e86da.svg";